import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { StrategyMapDownloadService } from '../strategy-map-download.service';

@Component({
  selector: 'app-strategy-map-confirm',
  templateUrl: './strategy-map-confirm.component.html',
  styleUrls: ['./strategy-map-confirm.component.scss']
})
export class StrategyMapConfirmComponent implements OnInit {
  @Output() close = new EventEmitter<void>();

  constructor(private strategyMapDownloadService: StrategyMapDownloadService) { }

  ngOnInit() {
  }

  get confirmHeader(): string {
    return this.strategyMapDownloadService.confirmHeader;
  }

  get confirmMessage(): string {
    return this.strategyMapDownloadService.confirmMessage;
  }

  onHideModalClick(): void {
    this.strategyMapDownloadService.clearVisible();
    this.close.emit();
  }

}
